/* import __COLOCATED_TEMPLATE__ from './phone-section.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsContactInfoPhoneSection extends Component {
  get phoneIsRequired() {
    if (this.connection.isCouple) return this.#couplePhoneRequirements;

    if (this.phoneNumberAttr === 'phoneNumber') return this.#primaryPhoneRequirements;

    return this.connection.isRequiredEmergencyContactPhoneNumber;
  }

  get #couplePhoneRequirements() {
    return (
      this.connection.isRequiredPhoneNumber || this.connection.isRequiredEmergencyContactPhoneNumber
    );
  }

  get #primaryPhoneRequirements() {
    if (this.connection.isMinor) return false;

    return this.connection.isRequiredPhoneNumber;
  }
}
